var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThumbsDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 1.33325H13.1134C13.4907 1.32658 13.8573 1.45867 14.1436 1.70446C14.43 1.95025 14.6161 2.29262 14.6667 2.66658V7.33325C14.6161 7.70721 14.43 8.04958 14.1436 8.29537C13.8573 8.54116 13.4907 8.67326 13.1134 8.66658H11.3334M6.66669 9.99992V12.6666C6.66669 13.197 6.8774 13.7057 7.25247 14.0808C7.62755 14.4559 8.13625 14.6666 8.66669 14.6666L11.3334 8.66658V1.33325H3.81335C3.4918 1.32961 3.17977 1.44231 2.93475 1.65058C2.68973 1.85884 2.52824 2.14864 2.48002 2.46658L1.56002 8.46658C1.53102 8.65768 1.5439 8.85279 1.59779 9.03841C1.65168 9.22403 1.74529 9.39572 1.87211 9.54157C1.99894 9.68743 2.15597 9.80396 2.33231 9.8831C2.50864 9.96225 2.70008 10.0021 2.89335 9.99992H6.66669Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsDown);
export default __webpack_public_path__ + "static/media/icon_thumbs_down.082c3bce19adcc70abf6dc84a6c69046.svg";
export { ForwardRef as ReactComponent };